import React, { useState } from 'react';
import { useUserAuth } from '../../Context/userAuthContext'; // UserAuthContext'ten hook'u alıyoruz
import { Button, Box } from "@mui/material";
import { isUser } from '../../Config/isUser';
import { isCompany } from '../../Config/isCompany';
import CircularProgress from "@mui/material/CircularProgress";

const UserLogin = () => {
  const { login } = useUserAuth(); // login fonksiyonunu alıyoruz

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [loginType, setLoginType] = useState("user"); // Seçilen login tipi

  // Giriş işlemi
  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password, loginType); // login fonksiyonunu çağırıyoruz
    } catch (err) {
      setError(err.message); // Hata durumunda kullanıcıya mesaj gösterme
    }
    finally {
      setLoading(false)
    }
  };

  return (
    <>{isUser || isCompany ? <div style={{ marginBottom: 100, marginTop: 200, justifyItems: "center" }}>
      <p style={{ fontSize: "50px" }}>Zaten giriş yaptınız önce çıkış yapınız</p>
      <Button style={{ backgroundColor: "#23c0e9", color: "black", marginTop: 50 }}><a href="/" style={{ color: "black" }}> Anasayfa'ya dön</a></Button>

    </div> : <div>
      <div className="jp_tittle_main_wrapper">
        <div className="jp_tittle_img_overlay" />
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div className="jp_tittle_heading_wrapper">
                <div className="jp_tittle_heading">
                  <h2>Site Girişi</h2>
                </div>
                <div className="jp_tittle_breadcrumb_main_wrapper">
                  <div className="jp_tittle_breadcrumb_wrapper">
                    <ul>
                      <li>
                        <a href="/">Anasayfa</a> <i className="fa fa-angle-right" />
                      </li>
                      <li>Giriş</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* login Kismi */}
      <div className="login_section">
        {/* login_form_wrapper */}
        <div className="login_form_wrapper">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2">
                {/* login_wrapper */}
                <h1>Üye GİRİŞİ</h1>
                <div className="login_wrapper">
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      gap: 3,
                      mb: 3
                    }}
                  >
                    <Button
                      variant={loginType === "user" ? "contained" : "outlined"}
                      onClick={() => setLoginType("user")}
                      sx={{
                        width: 250,
                        height: 50,
                        backgroundColor: loginType === "user" ? "#23c0e9" : "#fff",
                        color: loginType === "user" ? "#fff" : "#23c0e9",
                        borderColor: "#23c0e9",
                        "&:hover": {
                          backgroundColor: loginType === "user" ? "#a1eafd" : "#f5f5f5",
                        },
                      }}
                    >
                      KİŞİ
                    </Button>
                    <Button
                      variant={loginType === "company" ? "contained" : "outlined"}
                      onClick={() => setLoginType("company")}
                      sx={{
                        width: 250,
                        height: 50,
                        backgroundColor: loginType === "company" ? "#23c0e9" : "#fff",
                        color: loginType === "company" ? "#fff" : "#23c0e9",
                        borderColor: "#23c0e9",
                        "&:hover": {
                          backgroundColor: loginType === "company" ? "#a1eafd" : "#f5f5f5",
                        },
                      }}
                    >
                      Firma/Sağlık Kuruluşu
                    </Button>
                  </Box>
                  <div className="formsix-pos">
                    <div className="form-group i-email">
                      <input
                        type="email"
                        className="form-control"
                        required=""
                        id="email2"
                        placeholder="E-posta"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)} // e-posta input'unu state ile bağladık
                      />
                    </div>
                  </div>
                  <div className="formsix-e">
                    <div className="form-group i-password">
                      <input
                        type="password"
                        className="form-control"
                        required=""
                        id="password2"
                        placeholder="Şifre"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)} // şifre input'unu state ile bağladık
                      />
                    </div>
                  </div>
                  <div className="login_remember_box">
                    <a style={{ marginBottom: '20px' }} href="/forgotpassword" className="forget_password">
                      Şifremi unuttum
                    </a>
                  </div>
                  {error && <div style={{ color: 'red' }}>{error}</div>} {/* Hata mesajı */}
                  <div className="login_btn_wrapper">
                    <button
                      onClick={handleLogin}
                      className="btn btn-primary login_btn"
                      disabled={loading}
                    >
                      {loading ? <CircularProgress size={24} color="inherit" /> : "GİRİŞ yap"}
                    </button>
                  </div>
                  <div className="login_message">
                    <p>
                      Hesabınız yok mu  <a href="/register"> kayıt olun </a>
                    </p>
                  </div>
                </div>
                <p>
                  İlanlara başvurmak için giriş yapmanız gerekmektedir
                </p>
                {/* /.login_wrapper */}
              </div>
            </div>
          </div>
        </div>
        {/* /.login_form_wrapper */}
      </div>
    </div>}</>

  );
};

export default UserLogin;
